<script>
import { Application } from '@/api'
import ListMixin from '@/crudBases/list/ListMixin'

export default {
  mixins: [ListMixin],
  data() {
    return {
      editRouteName: 'Edit Application',
      verboseName: 'Application',
      verboseNamePlural: 'Applications',
      listFields: [
        { prop: 'student.first_name', label: "Student's first name" },
        { prop: 'student.last_name', label: "Student's last name" },
        {
          prop: 'created',
          label: 'Created',
          formatter: this.formatDate('created')
        },
        {
          prop: 'submitted_timestamp',
          label: 'Submitted',
          formatter: this.formatDate('submitted_timestamp')
        },
        { prop: 'status_display', label: 'Status' }
      ],
      filters: {
        available: [
          {
            name: 'Status',
            query_param: 'status',
            options: [
              { label: 'Open', value: 'open' },
              { label: 'In progress', value: 'started' },
              { label: 'Submitted', value: 'submitted' },
              {
                label: 'Submitted | Payment pending',
                value: 'payment_pending'
              },
              {
                label: 'Submitted | Payment received',
                value: 'payment_received'
              },
              {
                label: 'Submitted | Payment unsuccessful',
                value: 'payment_unsuccessful'
              },
              { label: 'Decision pending', value: 'decision_pending' },
              { label: 'Approved', value: 'assessment' },
              { label: 'Unsuccessful', value: 'unsuccessful' }
            ]
          }
        ]
      }
    }
  },
  computed: {
    service() {
      return Application
    }
  }
}
</script>
